module.exports = __webpack_public_path__ + "media/images/official/special_workcation_mochimuneb_04-5949006ddcb2446f8b4070f372b12947.jpeg";